import React from 'react'
import Video from './Video'

const Groupe = ({ nom, description, artistes, image, video, links }) => {
  console.log(links.map((l) => <a href={l.url}>{l.text}</a>))
  return (
    <div className={`groupe `}>
      <h4>{nom}</h4>
      {image != null && (
        <img
          width="100%"
          height="auto"
          src={
            image.includes('http') ? image : require(`../../images/${image}`)
          }
          alt={nom}
        />
      )}
      {video != null && <Video video={video} />}
      <p>{description}</p>
      {artistes != null && (
        <ul className="artistes">
          {Object.keys(artistes).map((a, i) => (
            <li key={i}>
              <strong>{a}</strong> : {artistes[a]}
            </li>
          ))}
        </ul>
      )}
      {links != null && links.length > 0 && (
        <p className='informations'>
          {links.map((l) => (
            <a href={l.url}>{l.text}</a>
          ))}
        </p>
      )}
    </div>
  )
}

export default Groupe
